export default function checkLanguageValidity(input, language) {
    const charRegex = {
        ru: /[а-яА-ЯёЁ]/g,
        uk: /[абвгдежзийклмнопрстуфхцчшщьюяєіїґАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЮЯЄІЇҐ']/g,
        ar: /[\u0621-\u064A\u0660-\u0669 ]/g,
    }

    // Remove all punctuation marks
    // eslint-disable-next-line no-useless-escape
    input = input.replace(/[\s\d\t§±!@#$%^&*()-_+=\[\]{}:;"'|\\<>,./\?]/g, '');

    // Remove all language-specific characters
    input = input.replace(charRegex[language], '');

    return input.length === 0;
}